export const burgerMenu = (() => {
	const buttonSelector = ".burger";
	const closeSelector = '[data-close="main-nav"]';
	const navClass = "menu-is-open";
	let buttonBurger;

	const toggleMenu = () => {
		const currentState = buttonBurger.getAttribute("data-state");
		const target = buttonBurger.getAttribute("aria-controls");
		const nav = document.querySelector(`#${target}`);

		if (!currentState || currentState === "closed") {
			buttonBurger.setAttribute("data-state", "opened");
			buttonBurger.setAttribute("aria-expanded", "true");
			nav.classList.add(navClass);
		} else {
			buttonBurger.setAttribute("data-state", "closed");
			buttonBurger.setAttribute("aria-expanded", "false");
			nav.classList.remove(navClass);
		}
	};

	const closeMenu = () => {
		const nav = document.querySelector(`.${navClass}`);
		if (nav) {
			buttonBurger.setAttribute("data-state", "closed");
			buttonBurger.setAttribute("aria-expanded", "false");
			nav.classList.remove(navClass);
		}
	};

	const init = () => {
		buttonBurger = document.querySelector(buttonSelector);

		if (buttonBurger) {
			buttonBurger.addEventListener("click", toggleMenu);

			const closeButton = document.querySelector(closeSelector);
			if (closeButton) {
				closeButton.addEventListener("click", closeMenu);
			}
		} else {
			console.warn(`Element matching selector "${buttonSelector}" not found.`);
		}
	};

	return {
		init,
	};
})();
